<template>
  <div>
    <b-dropdown variant="link" class="filter-dropdown">
      <template slot="button-content">
        <div class="d-flex align-items-center">
          <font-awesome-icon icon="photo-video"/>
          <span class="mx-2">Media Type</span>
        </div>
      </template>

      <b-dropdown-form>
        <b-form-checkbox v-model="showAll" class="my-1">
          <div class="d-flex align-items-center">
            <font-awesome-icon icon="asterisk"/>
            <span class="ml-2 py-1">Toggle All</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.artist_page" @input="updateFilter('artist_page', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2 py-1">Artist Pages</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.audio" @input="updateFilter('audio', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_audio"/>
            <span class="ml-2 py-1">Audio</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.book" @input="updateFilter('book', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_books"/>
            <span class="ml-2 py-1">Books</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.brand" @input="updateFilter('brand', $event)" class="my-1">
           <div class="d-flex align-items-center">
            <Icon icon="Menu_Brands"/>
            <span class="ml-2 py-1">Brands</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.external" @input="updateFilter('external', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_externals"/>
            <span class="ml-2 py-1">Externals</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.magazine" @input="updateFilter('magazine', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Magazines"/>
            <span class="ml-2 py-1">Magazines</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.page" @input="updateFilter('page', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2 py-1">Micropages</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.music_album" @input="updateFilter('music_album', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_music"/>
            <span class="ml-2 py-1">Music Albums</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.photo_package" @input="updateFilter('photo_package', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_camera"/>
            <span class="ml-2 py-1">Photo Packages</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.playlist_page" @input="updateFilter('playlist_page', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Categories"/>
            <span class="ml-2 py-1">Playlist Pages</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.podcast" @input="updateFilter('podcast', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_podcast"/>
            <span class="ml-2 py-1">Podcasts</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.series" @input="updateFilter('series', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Series"/>
            <span class="ml-2 py-1">Series</span>
          </div>
        </b-form-checkbox>
        <b-form-checkbox :checked="typeFilter.video" @input="updateFilter('video', $event)" class="my-1">
          <div class="d-flex align-items-center">
            <Icon icon="Menu_Videos"/>
            <span class="ml-2 py-1">Videos</span>
          </div>
        </b-form-checkbox>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'MediaTypeFilter',
  components: {
    Icon
  },

  data: function() {
    return {
      showAll: true,
      show: false
    };
  },

  computed: {
    collapseIcon() {
      if(this.show) return "expand_more-24px"
      else return "Expand_collapsed"
    },

    typeFilter() {
      return this.$store.state.media.typeFilter
    }
  },

  watch: {
    showAll(val) {
      this.$store.commit('media/typeFilterSetAll', val)
    }
  },

  methods: {
    toggle() {
      this.show = !this.show
    },

    updateFilter(type, value) {
      this.$store.commit('media/updateTypeFilter', {type, value})
    }
  }
}
</script>

<style scoped>
.b-dropdown-form {
  padding-left: 0.5rem !important;
  padding-right: 0.2rem !important;
}
</style>
